import isArrayNotEmpty from '@/tools/isarraynotempty';
import { TeamsType, RequestType } from './types';

const tutoredParce = (items: RequestType) => ({
  name: items!.fio.split(' ')[1] || '',
  lastname: items!.fio.split(' ')[0] || '',
  gender: items!.gender || 'N',
  photo: items!.photo || '',
});

const parceTeams = (data: TeamsType, tutoredId: string) => ({
  title: data!.title || '',
  curator: {
    name: data.curator_fio ? data.curator_fio.split(' ')[1] : '',
    lastname: data.curator_fio ? data.curator_fio.split(' ')[0] : '',
    email: data!.curator_email || '',
    phone: data!.curator_phone || '',
    image: data!.curator_photo || '',
    gender: data!.curator_gender || 'N',
  },
  mentor: {
    name: data.tutor_fio ? data.tutor_fio.split(' ')[1] : '',
    lastname: data.tutor_fio ? data.tutor_fio.split(' ')[0] : '',
    email: data!.tutor_email || '',
    phone: data!.tutor_phone || '',
    image: data!.tutor_photo || '',
    gender: data!.tutor_gender || 'N',
  },
  crew: isArrayNotEmpty(data.tutoreds)
    ? data.tutoreds.filter(({ id }) => id !== tutoredId).map(tutoredParce)
    : [],
});

export default parceTeams;



// WEBPACK FOOTER //
// ./src/services/mentoring/utils/parceTeams.ts